/* Quiet Luxury motion: content remains visible if animation is unavailable. */
(() => {
  if (window.rrStorefrontMotion || !window.IntersectionObserver || !Element.prototype.animate) return;
  window.rrStorefrontMotion = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  const candidates = '#MainContent h2, #MainContent .card-wrapper, #MainContent .multicolumn-card, #MainContent .rr-benefits__item, #MainContent .rr-water__copy, #valoraie-footer .footer-block';
  const excluded = '.scroll-trigger, .product__info-container, .product__media-wrapper, .rr-information, .product-set-upsell, .product__material-story, [role="dialog"], [aria-hidden="true"]';
  let observer;
  function scan(root = document) {
    if (preference.matches || !observer) return;
    const elements = [...root.querySelectorAll(candidates)];
    if (root.matches?.(candidates)) elements.unshift(root);
    elements.forEach(element => {
      if (seen.has(element) || element.closest(excluded)) return;
      // Avoid animating both a card and its nested title.
      if (element.matches('h2') && element.closest('.card-wrapper, .multicolumn-card, .rr-water__copy')) return;
      if (!element.getClientRects().length) return;
      const bounds = element.getBoundingClientRect();
      if (bounds.top < innerHeight) {
        seen.add(element);
        return; // Never delay the hero, initial products, or already-visible content.
      }
      observer.observe(element);
    });
  }
  function configure() {
    observer?.disconnect();
    active.forEach(animation => animation.cancel());
    active.clear();
    if (preference.matches) return;
    observer = new IntersectionObserver(entries => {
      let order = 0;
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const element = entry.target;
        observer.unobserve(element);
        if (seen.has(element)) return;
        seen.add(element);
        if (preference.matches || document.hidden) return;
        const heading = element.matches('h2');
        const animation = element.animate(
          heading
            ? [{opacity: .55, transform: 'translateY(8px)'}, {opacity: 1, transform: 'translateY(0)'}]
            : [{opacity: .55}, {opacity: 1}],
          {duration: 380, delay: Math.min(order++, 3) * 35, easing: 'cubic-bezier(.22,1,.36,1)'}
        );
        element.dataset.rrMotion = 'revealed';
        active.add(animation);
        animation.finished.then(() => active.delete(animation), () => active.delete(animation));
      });
    }, {threshold: .08});
    scan();
  }
  function start() {
    configure();
    preference.addEventListener('change', configure);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    // Recommendations and filtered products can arrive after the initial render.
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (preference.matches) return;
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) scan(node);
      }));
    }).observe(main, {childList: true, subtree: true});
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        active.forEach(animation => animation.cancel());
        active.clear();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
